import styled from 'styled-components';
export const Container = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: fit-content;
  opacity: ${_ref => {
  let {
    disabled
  } = _ref;
  return disabled ? '0.3' : '1';
}};
`;
export const StuntDouble = styled.input`
  background-color: transparent;
  border-radius: 50%;
  border: ${_ref2 => {
  let {
    inputSize
  } = _ref2;
  if (inputSize === 'sm') return '2px';
  if (inputSize === 'md') return '2.5px';
  if (inputSize === 'lg') return '3px';
}}
    solid ${_ref3 => {
  let {
    theme
  } = _ref3;
  return theme.colors.secondaryL2;
}};
  height: ${_ref4 => {
  let {
    inputSize
  } = _ref4;
  return inputSize === 'sm' ? '18px' : inputSize === 'md' ? '24px' : '30px';
}};
  width: ${_ref5 => {
  let {
    inputSize
  } = _ref5;
  return inputSize === 'sm' ? '18px' : inputSize === 'md' ? '24px' : '30px';
}};
  box-shadow: inset 0 0 0 2px transparent, inset 0 0 0 2px transparent;
  cursor: ${_ref6 => {
  let {
    disabled
  } = _ref6;
  return disabled ? 'not-allowed' : 'pointer';
}};
  margin: ${_ref7 => {
  let {
    inputSize
  } = _ref7;
  return inputSize === 'sm' ? '3px' : inputSize === 'md' ? '4px' : '5px';
}};

  input:not(:checked) + &:not(:disabled):hover,
  &:active,
  &:focus {
    ${_ref8 => {
  let {
    theme,
    disabled,
    inputSize
  } = _ref8;
  return !disabled && `
        outline: ${inputSize === 'sm' || inputSize === 'md' ? '2px' : '4px'}
          solid ${theme.colors.primaryL2}20;
        background-color: ${theme.colors.primaryL2}20;
    `;
}}
  }
`;
export const Label = styled.label`
  ${_ref9 => {
  let {
    theme,
    inputSize
  } = _ref9;
  return inputSize === 'sm' ? theme.fonts.infoSM : theme.fonts.infoLG;
}}
  color: ${_ref10 => {
  let {
    theme
  } = _ref10;
  return theme.colors.neutralL5;
}};
  margin-left: 4px;
  cursor: ${_ref11 => {
  let {
    disabled
  } = _ref11;
  return disabled ? 'not-allowed' : 'pointer';
}};
  white-space: nowrap;
`;
export const RadioInput = styled.input`
  cursor: ${_ref12 => {
  let {
    disabled
  } = _ref12;
  return disabled ? 'not-allowed' : 'pointer';
}};
  display: none;

  &:checked + ${StuntDouble} {
    background-color: ${_ref13 => {
  let {
    theme
  } = _ref13;
  return theme.colors.primaryL1;
}};
    border-color: ${_ref14 => {
  let {
    theme
  } = _ref14;
  return theme.colors.primaryL1;
}};
    box-shadow: inset
      ${_ref15 => {
  let {
    theme,
    inputSize
  } = _ref15;
  return inputSize === 'sm' ? `0 0 0 3px ${theme.colors.secondary}` : inputSize === 'md' ? `0 0 0 4px ${theme.colors.secondary}` : `0 0 0 4.5px ${theme.colors.secondary}`;
}};
  }
`;